import React from "react";
import { Button, ButtonGroup } from "reactstrap";

const Example = () => {
    return (
        <ButtonGroup>
            <Button className="c-primary">Left</Button>
            <Button className="c-primary">Middle</Button>
            <Button className="c-primary">Right</Button>
        </ButtonGroup>
    );
};

export default Example;
